import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useDeleteDraftOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "draftordercard",
        command: "delete",
        data: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orderListState"] });
    },
  });
};

// "data": "{\"data\":{\"filter\":{\"noFilter\":\"DF63960\"}}}"
